import { ReactNode } from 'react';
import { IconName } from '@optimus-web/icons';
import { DropdownItem, Icon } from '@optimus-web/core';

interface MenuButtonProps {
    icon?: IconName | undefined;
    label: ReactNode;
    onClick: () => void;
    destructive?: boolean;
}

export const MenuButton = ({ icon, label, onClick, destructive = false }: MenuButtonProps) => (
    <DropdownItem
        label={label}
        leftDetail={icon && <Icon value={icon} variant={destructive ? 'danger' : 'basic'} />}
        onClick={onClick}
        variant={destructive ? 'danger' : 'primary'}
    />
);
